import React, { useState } from 'react'
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login/Login"
import Home from "./pages/Home/Home"
import HomePage from "./pages/HomePage/HomePage"
import ConfigureEnv from "./pages/ConfigureEnv/ConfigureEnv"
import KeyVaultConfig from "./pages/KeyVaultConfig/KeyVaultConfig"
import RolesAndPermissions from "./pages/RolesAndPermissions/RolesAndPermissions"
import CreateClient from "./pages/CreateClient/CreateClient"
import Create from "./pages/Create/Create"
import SwitchClient from "./pages/SwitchClient/SwitchClient"
import MenuConfigurations from "./pages/MenuConfig/MenuConfigurations"
import DataMapping from "./pages/DataMapping/DataMapping"
import MaintainData from "./pages/MaintainData/MaintainData"
import Dashboard from "./pages/Dashboard/Dashboard"
import ApplicationFlow from "./pages/ApplicationFlow/ApplicationFlow"
import Error404 from './components/errors/Error404';
import ErrorAuth from './components/errors/ErrorAuth';
import ErrorPage from './components/errors/ErrorPage';
import UserPermission from "./pages/UserPermission/UserPermission"
import DeploymentStatus from './pages/DeploymentStatus/DeploymentStatus';
import AutomateFlows from './pages/Automation/Automation';
import Keyvault from './pages/Keyvault/Keyvault';
import MasterKeys from './pages/MasterKeys/MasterKeys';
import Releases from './pages/Releases/Releases';
import KeyVaultMigration from './pages/KeyVaultMigration/KeyVaultMigration';
import CreateTenant from './pages/CreateTenant/CreateTenant';
import AllTenants from './pages/CreateTenant/AllTenants';
import ViewTenant from './pages/CreateTenant/ViewTenant';
import AllTemplates from './pages/Templates/AllTemplates';
import TemplateConfig from './pages/Templates/TemplateConfig';
import TemplateDetails from './pages/Templates/TemplateDetails';
import ApplicationPermissions from './pages/CreateTenant/ApplicationPermissions';
import VaultList from './pages/Keyvault/VaultList';
import VaultDetail from './pages/Keyvault/VaultDetail';
import AddVault from './pages/Keyvault/AddVault';
import MigrationTool from './pages/Keyvault/MigrationTool';
import VaultCloneTool from './pages/Keyvault/VaultClone';
import { SearchProvider } from './pages/Keyvault/SearchContext';
import ConfigureTenant from './pages/CreateTenant/ConfigureTenant';

export default function MainRoutes() {

  // const { t } = useTranslation();
  const [errorMsg,setErrorMsg]=useState('');
  
  // const errmsg = localStorage.getItem('errorpage');
  const errmsg = false;
  // const errauth=localStorage.getItem('errorauth');
  return (
    <Routes>
      {/* <Route path='/logout' element={<Logout />} />   */}

      <Route path="/error" element={<ErrorAuth />} />

      <Route path="/" element={<Login />}>
        {errmsg && <Route path="*" element={<ErrorPage />} />}
        {!errmsg && (
          <>
            <Route index element={<HomePage />} />
            <Route path="/Home" element={<HomePage />} />
            <Route path="/FlowBuilder" element={<ApplicationFlow />} />
            <Route path="/Configure" element={<ConfigureEnv />} />
            <Route path="/KeyvaultConfigurations" element={<KeyVaultConfig />}/>
            <Route path="/keyvaultmigration" element={<KeyVaultMigration />} />
            <Route path="/DataMapping" element={<DataMapping />} />
            <Route path="/templates" element={<AllTemplates />} />
            <Route path="/templates/create" element={<TemplateConfig />} />
            <Route path="/templates/view/:id" element={<TemplateDetails />}/>
            <Route path="/CreateClient" element={<CreateClient />} />
            <Route path="/Create" element={<Create />} />
            <Route path="/tenants" element={<AllTenants />} />
            <Route path="/tenants/create" element={<CreateTenant />} />
            <Route path="/tenants/configure/:id" element={<ConfigureTenant />} />
            <Route path="/tenants/view/:id" element={<ViewTenant />} />
            <Route path="/tenants/permissions/:id" element={<ApplicationPermissions />} />
            <Route path="/SwitchClient" element={<SwitchClient />} />
            <Route path="/MenuConfigurations" element={<MenuConfigurations />}/>
            <Route path="/RolesAndPermissions" element={<RolesAndPermissions />}/>
            <Route path="/MaintainData" element={<MaintainData />} />
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/errorInvalid" element={<ErrorPage />} />
            <Route path="/DeploymentStatus" element={<DeploymentStatus />} />
            <Route path="/MasterKeys" element={<MasterKeys />} />
            <Route path="/Releases" element={<Releases />} />
            <Route path="/Automation" element={<AutomateFlows />} />
            <Route path="/Keyvaults" element={<SearchProvider> <VaultList /></SearchProvider>} />
            <Route path="/Keyvault/:id" element={<SearchProvider> <VaultDetail /></SearchProvider> } />
            <Route path="/Keyvault/new" element={<SearchProvider>  <AddVault /> </SearchProvider> } />
            <Route path="/Keyvault/:vaultName/:vaultId" element={<SearchProvider> <VaultDetail /></SearchProvider> } />
            <Route path="/Keyvaults/migrate" element={<SearchProvider>  <MigrationTool /> </SearchProvider> } />
            <Route path="/Keyvaults/clone" element={<SearchProvider>  <VaultCloneTool /> </SearchProvider> } />
            <Route path="*" element={<Error404 />} />
          </>
        )}
      </Route>
    </Routes>
  );
}
